import { gsap, ScrollTrigger, ScrollToPlugin } from "gsap/all";

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

window.addEventListener("load", () => {
  const productsSections = gsap.utils.toArray(".section-products-slider");
  productsSections && productsSections.forEach(products => {
    const productItems = products.querySelectorAll(".section-products-slider-product");
    const productsNav = products.querySelector('.section-products-slider-products__nav');
    const productButtons = productsNav?.querySelectorAll('.section-products-slider-products__nav-btn');
    const numOfTransitions = productItems.length;
    const singleDuration = 100; // percent of section
    const totalDuration = singleDuration * numOfTransitions;

    productsNav.addEventListener('click', (e) => {
      const scrollOffset = window.innerHeight >= 1024 ? (window.innerHeight - document.querySelector(`${e.target.dataset.product} .section-products-slider-product`).clientHeight) / 2 : 0;
      gsap.to(window, { scrollTo: { y: e.target.dataset.product, smooth: 1, autoKill: true, offsetY: scrollOffset }});
    });

    const updateProductButtons = (i) => {
      const activeProduct = products.querySelector('.section-products-slider-products__nav-btn.active');
      if (activeProduct && activeProduct !== productButtons[i] && (productButtons.length !== i )) {
        activeProduct.classList.remove('active'); 
        activeProduct.tabIndex = '-1';
      } 

      productButtons[i].classList.add('active');
      productButtons[i].tabIndex = 0;
    }

    ScrollTrigger.create({
      trigger: products,
      start: "top bottom",
      onEnter: () => {
        if (!products.classList.contains('update')) {
          setTimeout(() => ScrollTrigger.refresh(), 300);
          products.classList.add('update');
        }
      },
    });

    const mm = gsap.matchMedia();
    mm.add(
      {
        small: '(max-width: 768px)',
        large: '(min-width: 769px)',
      },
      (ctx) => {
        const { large } = ctx.conditions;
        ScrollTrigger.create({
          trigger: productsNav,
          start: large ? "center center" : `top 80px`,
          end: '+=' + `${totalDuration - 105}%`,
          pin: true,
          pinSpacing: false,
        });
      }
    );

    productItems && productItems.forEach((product, i) => {
      product.addEventListener('focus', () => {
        const scrollOffset = window.innerHeight >= 1024 ? (window.innerHeight - product.clientHeight) / 2 : 0;
        gsap.to(window, { scrollTo: { y: product.parentNode, autoKill: true, offsetY: scrollOffset }});
      });

      mm.add({
        small: '(max-width: 768px)',
        large: '(min-width: 769px)',
      },
      (ctx) => {
        const { large } = ctx.conditions;
        ScrollTrigger.create({
          trigger: product,
          start: large ? "center center" : "top 100px",
          end: '+=' + `${totalDuration - ((i + 1) * 100)}%`,
          pin: i !== productItems.length - 1 ? true : false,
          pinSpacing: false,
        });

        ScrollTrigger.create({
          trigger: product,
          start: "center 80%",
          onEnter: () => {
            updateProductButtons(i);
          },
          onLeaveBack: () => {
            i !== 0 && updateProductButtons(i - 1);
          },
        });

        if(i !== productItems.length - 1) {
          gsap.timeline({
            paused: true,
            ease: 'none',
            scrollTrigger: {
              trigger: product,
              start: large ? "center center" : "top 165px",
              end: large ? "+=80%" : "+=50%",
              toggleActions: "play none none reverse",
              scrub: true,
            },
          }).to(product, { scale: 0.7, opacity: 0 });
        }
      });
    });
  });
});
